var _ = require('lodash');
var tpl = require('./select_city_tpl.html');
var handle = _.template(tpl, {variable: 'data'});

var cityService = require('../../services/cityService');

let $ = window.$;

var _store = {
    // 这里为$dom创建一个匿名或命名的容器空间
    $dom: $('<div>'),
    // 这里用来存储实际$html内容
    $html: {},
    callback: function (code) {},
    activeCode: $.cookie('ipCity')
};

var _control = {
    // 初始化html模板，将dom操作交给bind
    init: function () {
        var that = this;
        $.when(cityService.getCity_async()).then(function (data) {
            if (!data) {
                console.error('未知错误');
            } else {
                var html = handle({
                    data: {
                        '城市': data
                    },
                    activeCode: _store.activeCode
                });
                that.bind(html);
            }
        });
    },
    // 绑定事件，当然也离不开dom操作
    bind: function (html) {
        _store.$html = $(html).addClass('hidden').appendTo(_store.$dom);
        _store.$html.find('.slide-mask-layer').on('click', function(event) {
            event.preventDefault();
            _store.$html.addClass('hidden');
        });
        _store.$html.find('.slide-item').on('click', function(event) {
            event.preventDefault();
            var code = $(this).attr('data-code');
            _store.callback(code);
        });
    }
};

_control.init();

module.exports = {
    $dom: _store.$dom,
    do: function (callback) {
        _store.$html.removeClass('hidden');
        _store.callback = function (code) {
            _store.$html.addClass('hidden');
            callback(code);
        };
    },
    _more: ''
};



// WEBPACK FOOTER //
// ./src/modules/sellcar/modules/select_city/select_city.js